import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { notification } from 'antd';
import useGlobalState from '../../../../Template/atoms/variables';
import { useEffect } from 'react';

const InstrumentsOutlet = () => {
  const navigate = useNavigate();
  const { plantId } = useParams();
  const { setPendingApiCalls } = useGlobalState();

  useEffect(() => {
    triggerApiCalls();
  }, [plantId]);

  const triggerApiCalls = async () => {
    try {
      // Validar se plantId existe
      if (!plantId) {
        notification.error({
          message: 'Erro',
          description: 'ID da planta não encontrado',
          duration: 5,
        });
        navigate('/maintenance/plants');
        return;
      }
    } finally {
    }
  };

  return <Outlet />;
};

export default InstrumentsOutlet;
